import React from 'react'
import { sendGamificationEngagement, type FeedItem } from '../../../Api'
import { useAuthContext } from '../../../Context'
import { getPartnerLabel, logEvent } from '../../../Utils'
import {
  ArticleTitle,
  ArticleAuthor,
  ArticleCon,
  TitleCon,
  PartnerLabel,
} from './styles'
import { Img } from '../../Image/Img'
import { ANALYTICS_TAGS, gamificationEngagements } from '../../../Constant'
import { Lk } from '../../Links/Lk'

type ArticleCardProps = {
  article: FeedItem
  theme?: 'light' | 'dark'
  section?: string
  size?: 'home_featured' | 'featured' | 'normal' | 'small'
  index?: number
}

export const ArticleCard: React.FC<React.PropsWithChildren<ArticleCardProps>> = ({
  article,
  section,
  theme = 'light',
  size,
  index,
}) => {
  const { isLoggedIn, userId } = useAuthContext()

  const log = (eventName: string) => {
    if (isLoggedIn && userId) {
      sendGamificationEngagement(
        userId,
        gamificationEngagements.ARTICLE_READ,
        article.id
      )
    }
      const params = {
        feed_type: 'article',
        title: article?.title,
        tags: article?.tags,
        item_id: article?.id,
        article_id: article?.id,
        location: section ?? article?.metaData?.section?.location ?? '',
        feed: 'home',
        position: index ?? 0,
      }
      Promise.all([
        logEvent(eventName, params),
        logEvent(ANALYTICS_TAGS.feed_item_click, params),
      ])
  }

  return (
    <ArticleCon size={size} uiTheme={theme}>
      <Lk
        link={article.shareLink}
        alt={article?.title}
        onBeforeNavigate={() => log(ANALYTICS_TAGS.article_click)}
        awaitBeforeNavigate={false}
      >
        {article?.previewImage ? (
          <Img className="cover" src={article.previewImage} alt={article.title || ''} />
        ) : (
          <div className="placeholder" />
        )}
        <TitleCon uiTheme={theme}>
          {article.partnerId && (
            <PartnerLabel uiTheme={theme}>
              <p>{getPartnerLabel(article)}</p>
            </PartnerLabel>
          )}
          <ArticleTitle uiTheme={theme}>{article.title || ''}</ArticleTitle>
        </TitleCon>
      </Lk>
      {article?.authorName && (
        <Lk
          link={article.authorLink ? article.authorLink : article.shareLink}
          alt={`${article.authorName} - ${article.title}`}
          onBeforeNavigate={() => log(ANALYTICS_TAGS.article_author_click)}
          awaitBeforeNavigate={false}
        >
          <ArticleAuthor uiTheme={theme}>By {article.authorName}</ArticleAuthor>
        </Lk>
      )}
    </ArticleCon>
  )
}
